import { motion } from 'framer-motion';
import { CalendarDays, Play } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import { trackCTA } from '../utils/analytics';

const Demo = () => (
  <>
    <SEOHead
      title="Demo"
      description="Explore a BuildOrq walkthrough covering AI-assisted estimations, generated house plans, daily site work, documents, materials, finance, inspections, notifications, and analytics."
      url="https://buildorq.com/demo"
    />

    <div className="border-b border-slate-200 bg-white">
      <div className="container-custom py-16 lg:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">See it in action</p>
          <h1 className="section-title mt-2">Walk through the BuildOrq construction workspace.</h1>
          <p className="mt-4 text-lg text-surface-body">
            See how a team moves from AI-assisted planning into live site,
            material, finance, quality, notification, and reporting workflows.
          </p>
        </div>
      </div>
    </div>

    <div className="bg-surface-page py-16">
      <div className="container-custom">
        <div className="mx-auto max-w-4xl space-y-12">

          {/* Demo preview */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex aspect-video items-center justify-center rounded-2xl border border-slate-200 bg-white p-8 shadow-card"
          >
            <div className="max-w-2xl text-center">
              <Play size={48} className="mx-auto text-primary-600" aria-hidden />
              <h2 className="mt-5 text-2xl font-bold text-surface-ink">
                Guided product walkthrough
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-surface-body">
                The demo covers project setup, estimate generation, house plan
                creation, document control, materials flow, finance approvals,
                inspections, daily site reports, notifications, and analytics.
              </p>
              <div className="mt-6 flex flex-wrap justify-center gap-2 text-xs font-semibold text-slate-500">
                {['Estimations', 'House Plans', 'Daily Site', 'Materials', 'Finance', 'Inspections'].map(item => (
                  <span key={item} className="rounded-full bg-slate-100 px-3 py-1">
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </motion.div>

          {/* CTA row */}
          <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-center">
            <a
              href="https://app.buildorq.com/signup"
              rel="noopener noreferrer"
              onClick={() => trackCTA('signup', 'demo_cta')}
              className="btn-primary"
            >
              Sign up free — no card needed
            </a>
            <a
              href="/contact"
              onClick={() => trackCTA('book_call', 'demo_cta')}
              className="btn-secondary flex items-center gap-2"
            >
              <CalendarDays size={16} aria-hidden />
              Book a live walkthrough
            </a>
          </div>

        </div>
      </div>
    </div>
  </>
);

export default Demo;
